import { SimulatorProductsInterface } from '../../../../interfaces/dto/simulator/products/simulator-products-interface';

export class SimulatorProductsModel implements SimulatorProductsInterface {
  productType?: string;
  productSimulationGroup?: string;
  productName: string = '';
  formIdentificationTag: string = '';
  canSubscribe: boolean = false;
  canDownloadSimulation: boolean = false;
  canSendSimulationEmail: boolean = false;

  constructor(init?: Partial<SimulatorProductsModel>) {
    Object.assign(this, init);
  }
}
